<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("user/fetchUserInfo");
    if (this.$store.getters["user/isLogin"]) {
      this.$store.dispatch("cart/fetchCart");
    }
  },
  methods: {},
};
</script>

<style lang="less">
@import "./assets/style/common.less";
</style>



// WEBPACK FOOTER //
// src/App.vue